<template>
    <div class="space-y-2">
        <template
            v-for="customField in customFields"
            :key="customField.id.value"
        >
            <CustomFieldInputRenderer
                :customField="customField"
                :savedValue="
                    draftMeeting.getSavedResponseForCustomField(customField.id)
                "
                :errors="errors ?? {}"
            />
        </template>
    </div>
</template>

<script setup lang="ts">
    import { type PropType } from 'vue'
    import DraftMeeting from '@/App/Booking/Draft/Entity/DraftMeeting'
    import CustomField from '@/App/CustomField/Entity/CustomField'
    import CustomFieldInputRenderer from '@/BookingForm/BookingForm/Component/CustomField/CustomFieldInputRenderer.vue'
    import ApiFormErrors from '@/Shared/Component/Forms/ApiFormErrors'

    const props = defineProps({
        customFields: {
            type: Object as PropType<CustomField[]>,
            required: true,
        },
        draftMeeting: {
            type: Object as PropType<DraftMeeting>,
            required: true,
        },
        errors: {
            type: Object as PropType<ApiFormErrors>,
            required: true,
        },
    })
</script>
